<div class="dialog-header">
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form style="width: 100%" [formGroup]="form" (ngSubmit)="submitForm()">
  <h3 style="text-align: center">{{ !isNew ? "Actualizar Contacto" : "Agregar Contacto" }}</h3>
  <article class="form_purchase contenedor_update">
    <section class="container-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="nameContact" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Apellido</mat-label>
        <input matInput formControlName="lastNameContact" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Rut</mat-label>
        <input matInput formControlName="fullRutContact" (blur)="inputRut($event)" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput formControlName="emailContact" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Preferencia de contacto</mat-label>
        <mat-select #select multiple formControlName="preferredContact">
          <div class="select-all">
            <mat-checkbox
              [(ngModel)]="allSelected"
              [ngModelOptions]="{ standalone: true }"
              (change)="toggleAllSelection()"
              >Seleccionar Todos</mat-checkbox
            >
          </div>
          <mat-option
            (click)="optionClick()"
            *ngFor="let type of contactType"
            [value]="type.value"
          >
            {{ type.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Producto de interes</mat-label>        
        <mat-select #select2 multiple formControlName="infoPreferences">
            <div class="select-all">
              <mat-checkbox
                [(ngModel)]="allSelected2"
                [ngModelOptions]="{ standalone: true }"
                (change)="toggleAllSelection2()"
                >Seleccionar Todos</mat-checkbox
              >
            </div>
            <mat-option
              (click)="optionClick()"
              *ngFor="let type of preferences"
              [value]="type.value"
            >
              {{ type.viewValue }}
            </mat-option>
          </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Telefono</mat-label>
        <input matInput formControlName="phoneContact" type="text" />
      </mat-form-field>
    </section>
  </article>
  <section class="contenedor_boton">
    <button
      mat-flat-button
      color="primary"
      class="w-50"
      type="submit"
      [disabled]="this.form.invalid"
    >
    {{ !isNew ? "Actualizar" : "Guardar" }}
    </button>
  </section>
</form>

<ng-template #loading>
  <mat-spinner [diameter]="40"></mat-spinner>
</ng-template>
